import styles from './index.module.scss';
import ImgElementFunny from '@/assets/productCenter/phonics/funny-element.png';
import ImgElementLove from '@/assets/productCenter/phonics/love-element.png';
import ImgElementMaterial from '@/assets/productCenter/phonics/material-element.png';
import { useScreenSlideIn } from '@/hooks/useScreenSlideIn';

const ELEMENT_LIST = [
  {
    img: ImgElementFunny,
    title: '有趣',
    desc: '孩子注意力集中时间短，我们把知识融入他们熟悉的场景、游戏、故事之中，用生动形象的语言活泼有趣的互动形式，点燃孩子们的学习兴趣。',
  },
  {
    img: ImgElementMaterial,
    title: '有料',
    desc: '针对低龄段认知规律，我们设计出一套符合这一阶段的孩子的认知规律，兼具科学性、逻辑性和实用性的成长体系。',
  },
  {
    img: ImgElementLove,
    title: '有爱',
    desc: '通过AI实现大规模个性化精准互动，即时关注、即时回应，让线上教学拥有线下的互动感和温度，真正实现“以孩子为中心”。',
  },
];

export default function Screen2() {
  const slideInRef = useScreenSlideIn({
    triggerSlideRatio: 1,
    animationClassName: styles['screen2-anim-start'],
    triggerOnce: true,
  });

  const contentSlideInRef = useScreenSlideIn({
    triggerSlideRatio: 1.1,
    animationClassName: styles['screen2-content-anim-start'],
    triggerOnce: true,
  });

  return (
    <section className={styles['screen2-container']} ref={slideInRef.ref}>
      <h2 className={styles['screen2-title']}>三大核心必要元素</h2>
      <div className={styles['screen2-content']} ref={(el) => (contentSlideInRef.ref.current = el)}>
        {ELEMENT_LIST.map((item) => (
          <div key={item.title} className={styles['screen2-item']}>
            <img
              className={styles['screen2-item-img']}
              src={item.img}
              alt={item.title}
              loading="lazy"
            />
            <div className={styles['screen2-item-content']}>
              <div className={styles['screen2-item-title']}>{item.title}</div>
              <div className={styles['screen2-item-desc']}>{item.desc}</div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
